import { render, staticRenderFns } from "./LoaderDialog.vue?vue&type=template&id=24f8da53&scoped=true"
import script from "./LoaderDialog.vue?vue&type=script&lang=js"
export * from "./LoaderDialog.vue?vue&type=script&lang=js"
import style0 from "./LoaderDialog.vue?vue&type=style&index=0&id=24f8da53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f8da53",
  null
  
)

export default component.exports